import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/lock.svg'
import _imports_1 from '../assets/generic-module.svg'


const _withScopeId = n => (_pushScopeId("data-v-29d5d104"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = {
  id: "lock-icon",
  src: _imports_0
}
const _hoisted_3 = { class: "module-icon" }
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  alt: "module logo"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  id: "title",
  class: "small_headline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModuleProgresBar = _resolveComponent("ModuleProgresBar")!

  return (_openBlock(), _createElementBlock("div", {
    id: "module",
    class: _normalizeClass(["col-2", {
      'module-active': _ctx.module.state?.active,
      'show-cursor': _ctx.module.enabled,
      'apply-opacity': !_ctx.module.enabled || _ctx.module.disallowed
    }]),
    title: _ctx.dependsOnTargetTitle
  }, [
    _createElementVNode("div", {
      id: "module-content",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToModulePage(_ctx.module)))
    }, [
      _createElementVNode("h4", {
        id: "current",
        class: "small_headline",
        style: _normalizeStyle({
          visibility: _ctx.module.state?.active ? 'visible' : 'hidden'
        })
      }, _toDisplayString(_ctx.$t("MODULES.CURRENT_MODULE")), 5),
      _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
        [_vShow, !_ctx.module.enabled || _ctx.module.disallowed]
      ]),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.module.image)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.module.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.generateImageUrl(_ctx.module),
              alt: "module logo"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_ModuleProgresBar, {
        progress: _ctx.module.state.progress
      }, null, 8, ["progress"])
    ])
  ], 10, _hoisted_1))
}